import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp2002',
    ecrans: ['00-2'],
    params: ['doccleint']
});
